import "core-js/modules/es6.array.find";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { LOCALES, DEFAULT_LOCALE } from '~/const/i18n';
import { NEW_RELIC_SCRIPT_SET } from '@/store/modules/script/types';
export default {
  nuxtServerInit: function () {
    var _nuxtServerInit = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(_ref, _ref2) {
      var commit, params, req, response, locale, protocol, baseURL;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit;
              params = _ref2.params, req = _ref2.req;
              _context.next = 4;
              return this.$axios.post('/new-relic/script', {});

            case 4:
              response = _context.sent;
              if (response && response.data && response.data.newRelicScript) commit(NEW_RELIC_SCRIPT_SET, response.data.newRelicScript);
              locale = LOCALES.filter(function (obj) {
                return obj.market === params.market;
              }).find(function (obj) {
                return obj.language === params.language;
              }) || DEFAULT_LOCALE;
              commit('i18n/SET_LOCALE', locale);
              this.app.i18n.locale = locale.language;
              protocol = req.headers['x-forwarded-proto'] || 'http';
              baseURL = req ? "".concat(protocol, "://").concat(req.headers.host) : '';
              commit('request/SET_BASE_URL', baseURL);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function nuxtServerInit(_x, _x2) {
      return _nuxtServerInit.apply(this, arguments);
    }

    return nuxtServerInit;
  }()
};